import { Dispatch } from "redux";


import {
    AuthenticationActionsTypes
} from "@Actions-Types";

import {
    AuthenticationActions
} from "@Actions";

import {
    QyvoUserModel
} from "Models/@GUI/Users";


export const UserSignInAction = (QyvoUser: QyvoUserModel) => {

    return (dispatch: Dispatch<AuthenticationActions>) => {
        dispatch({
            type: AuthenticationActionsTypes.USER_SIGN_IN,
            QyvoUser: QyvoUser
        });
    };

};


export const UserSignOutAction = () => {

    return (dispatch: Dispatch<AuthenticationActions>) => {
        dispatch({
            type: AuthenticationActionsTypes.USER_SIGN_OUT
        });
    };

};
